import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AppNotification } from './floating-notification.model';
import {SystemApp} from "../../constans/SystemConfigurations";
import {HttpClient} from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class FloatingNotificationService {

    private notificationsSubject = new BehaviorSubject<AppNotification[]>([]);
    notifications$ = this.notificationsSubject.asObservable();

    private allNotifications: AppNotification[] = [];
    private loaded = false;
    private apiUrl = `${SystemApp.base_url_api}/notification-api/floating-notifications/`;

    constructor(private http: HttpClient) {}


    // ✅ Your existing show (slightly improved)
    show(notification: AppNotification) {
        const id = this.generateId();

        const notif = { ...notification, id };

        const current = this.notificationsSubject.value;
        this.notificationsSubject.next([...current, notif]);

        if (notif.duration) {
            setTimeout(() => this.close(id), notif.duration);
        }
    }

    loadAll() {
        if (this.loaded) return;

        this.loaded = true;

        this.http.get<any>(this.apiUrl).subscribe(response => {
            const now = new Date();

            this.allNotifications = response.results.filter((n: AppNotification) => {
                if (!n.is_active) return false;

                const startOk = !n.start_at || new Date(n.start_at) <= now;
                const endOk = !n.end_at || new Date(n.end_at) >= now;

                return startOk && endOk;
            });
        });
    }

    showByCode(code: string) {
        const notification = this.allNotifications.find(n => n.code === code);

        if (!notification) return;

        this.show(notification);
    }


    close(id: string) {
        const filtered = this.notificationsSubject.value.filter(n => n.id !== id);
        this.notificationsSubject.next(filtered);
    }

    private generateId(): string {
        return Math.random().toString(36).substring(2);
    }
}